module.exports = __webpack_public_path__ + "img/budget2.6bceb513.svg";